import { MinzeElement, Reactive, EventListeners } from 'minze'
import { replaceTemplate } from '../../modules/utils'
import MainModule from '../../modules/main'
import { escapeHtml, cloneObject } from '../../modules/utils'

interface AuthStatusEvent {
  isLoggedIn: boolean
}

export interface LvcAuthTemplatedText {
  isLoggedIn: boolean
}

export class LvcAuthTemplatedText extends MinzeElement {
  _authHandler: any = null
  _initialized: boolean = false
  _renderedString: string = ''
  reactive: Reactive = [['isLoggedIn', false]]
  _renderData: any = {}

  html() {
    if (!this._renderData) return ''
    let rendered = replaceTemplate(this.innerHTML, this._renderData || {})

    return `${this._initialized && this.isLoggedIn ? rendered : ''}`
  }

  onStart(): void | Promise<void> {
    let mainModule = MainModule.getInstance()
    this._authHandler = this.handleAuthChanged.bind(this)
    mainModule.getEE().on('lvc:user_state_changed', this._authHandler)
    this.handleTemplating(mainModule.getAuth().isLoggedIn())
  }

  onDestroy(): void {
    let mainModule = MainModule.getInstance()
    mainModule.getEE().off('lvc:user_state_changed', this._authHandler)
  }

  onReady() {
    let mainModule = MainModule.getInstance()
    this.handleTemplating(mainModule.getAuth().isLoggedIn())
  }

  handleAuthChanged = async (data: any): Promise<void> => {
    this.handleTemplating(data?.isLoggedIn)
  }

  async handleTemplating(isLoggedIn?: boolean): Promise<void> {
    if (isLoggedIn) {
      let mainModule = MainModule.getInstance()
      let userData = await mainModule.getAuth().loadProfile()
      this._renderData = {}

      if (userData?.personalData) {
        this._renderData = cloneObject(userData?.personalData)
      }

      for (let key in this._renderData) {
        this._renderData[key] = escapeHtml(this._renderData[key])
      }

      this._initialized = true
      this.isLoggedIn = true
      this.rerender()
    } else {
      this.isLoggedIn = false
      this._initialized = true
      this.rerender()
    }
  }

  css = () => `
    :host {
      display: inline-block;
    }


  `
}
